import { render } from "./PytanieOdpowiedz.vue?vue&type=template&id=182e8585&scoped=true"
import script from "./PytanieOdpowiedz.vue?vue&type=script&lang=js"
export * from "./PytanieOdpowiedz.vue?vue&type=script&lang=js"

import "./PytanieOdpowiedz.vue?vue&type=style&index=0&id=182e8585&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182e8585"]])

export default __exports__